import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-allocation-form',
  templateUrl: './project-allocation-form.component.html',
  styleUrls: ['./project-allocation-form.component.css']
})
export class ProjectAllocationFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
